import React, { Fragment } from 'react';

const MentorChatRules = () => {
  return (
    <Fragment>
      <div className="stream-section-container">
        <div className="padding-container">
          <div className="title-container-info">
            <div className="border-alt red">
              <p className="online-title-alt red">Chat Rules</p>
            </div>
          </div>
          <ul className="stream-container-items">
            <li className="stream-container-item">
              Be Respectful
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              No racism, homophobic comments, profanity, bullying or any acts of
              hate and / or descrimination
            </li>
            <li className="stream-container-item">
              Spamming
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              No links to any content, unless approved by channel mentor
            </li>
            <li className="stream-container-item">
              Live Link Requests
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Live Link Requests will only be permitted towards the end of the
              stream. I will try to link as many requests as I can
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default MentorChatRules;
